// Single source of truth for the MEES frequentation code lists
// (funding source, path type, exemption code). These were previously inline in
// views/planning/frequentation-form.vue; extracted here so the frequentation form
// and the reusable StudentFilter share identical option lists.

export interface CodeOption {
  label: string;
  value: string;
}

export const fundingSourceOptions: CodeOption[] = [
  { label: '01 – Ministère', value: '01' },
  { label: '02 – Ministère-Enveloppe dédiée', value: '02' },
  { label: '03 – Autofinancement-Élève', value: '03' },
  { label: '04 – Autofinancement-OS', value: '04' },
  { label: '05 – Autofinancement-Industrie', value: '05' },
  { label: '06 – MESS', value: '06' },
  { label: '07 – MIFI', value: '07' },
  { label: '08 – Autres min. provinciaux', value: '08' },
  { label: '09 – Autres min. fédéraux', value: '09' },
  { label: '10 – Autre - Gouvernement régional', value: '10' },
];

export const pathTypeOptions: CodeOption[] = [
  { label: '01 – Reconnaissance des acquis', value: '01' },
  { label: '02 – Traditionnel', value: '02' },
  { label: '03 – Alternance travail-études', value: '03' },
  { label: '04 – Formation commune', value: '04' },
  { label: '05 – Formation générale', value: '05' },
  { label: '06 – Formation générale appliquée', value: '06' },
  { label: '07 – Formation préparatoire au travail', value: '07' },
  { label: '08 – Métier semi-spécialisé', value: '08' },
  { label: '10 – Intégration socioprofessionnelle', value: '10' },
  { label: '11 – Formation diversifiée', value: '11' },
  { label: '12 – Formation spécifique', value: '12' },
  { label: '13 – Soutien pédagogique', value: '13' },
  { label: '14 – Hors programme', value: '14' },
  { label: '17 – Formation à distance', value: '17' },
  { label: '19 – Compétences à la carte', value: '19' },
];

export const exemptionCodeOptions: CodeOption[] = [
  { label: '11 – CC/RP – Né ou adopté au Qc', value: '11' },
  { label: '12 – CC/RP – Parent-répondant réside au Qc', value: '12' },
  { label: '13 – CC/RP – Décès parent-répondant au Qc', value: '13' },
  { label: '14 – CC/RP – Parent-répondant quitte Qc', value: '14' },
  { label: '15 – CC/RP – Réside au Qc depuis 12 mois', value: '15' },
  { label: '16 – CC/RP – Titulaire CSQ', value: '16' },
  { label: '17 – CC/RP – Réside au Qc depuis 3 mois', value: '17' },
  { label: '18 – CC/RP – Résidence 3 sur 5 ans au Qc', value: '18' },
  { label: '19 – CC/RP – Conjoint résident du Qc', value: '19' },
  { label: '20 – Autorité parentale demeure de façon habituelle au Qc', value: '20' },
  { label: '30 – Personne autorisée par le protocole du Gouvernement du Québec', value: '30' },
  { label: '31 – Titulaire du permis de travail - Francisation', value: '31' },
  { label: '32 – Enfant et conjoint du titulaire d’un permis de travail au Québec', value: '32' },
  { label: '33 – Titulaire / enfant du permis de séjour temporaire', value: '33' },
  { label: '34 – Enfant du titulaire du permis d’études au Québec', value: '34' },
  { label: '35 – Programme d’échange scolaire', value: '35' },
  { label: '36 – Ressortissant d’un État avec lequel le Québec a signé une entente en vue de l’exemption de la contribution financière', value: '36' },
  { label: '37 – FGJ – Demandeur d’asile', value: '37' },
  { label: '38 – FGA – Demandeur d’asile', value: '38' },
  { label: '39 – Demande RP au Canada - Catégorie regroupement familial, cas humanitaire ou membre de la famille d’un réfugié', value: '39' },
  { label: '40 – Réfugié reconnu', value: '40' },
  { label: '42 – CC/RP réside au Qc durant l’année scolaire', value: '42' },
  { label: '43 – Quota Éducation internationale', value: '43' },
  { label: '44 – Bourse Éducation internationale', value: '44' },
  { label: '45 – Enfant à charge - Demandeur d\'asile', value: '45' },
  { label: '46 – Enfant à charge d’un réfugié', value: '46' },
  { label: '47 – Enfant à charge d’un titulaire de permis de travail échu depuis moins d’un an', value: '47' },
  { label: '48 – Enfant à charge d’un titulaire de permis d’études échu depuis moins d’un an', value: '48' },
  { label: '49 – Mineur placé sur le territoire d’un centre de services scolaire ou d’une commission scolaire selon l’article 204 de la LIP', value: '49' },
  { label: '50 – Citoyen canadien ou résident permanent ou enfant de celui-ci qui réside en pensionnat au Québec', value: '50' },
  { label: '51 – Citoyen canadien ou résident permanent et la personne qui assume de fait sa garde demeure de façon habituelle au Qc', value: '51' },
  { label: '52 – Titulaire de l’autorité parentale est citoyen canadien ou résident permanent et la personne qui assume de fait sa garde demeure de façon habituelle au Qc', value: '52' },
  { label: '53 – Titulaire/enfant du permis de séjour temporaire – Alphabétisation / Francisation', value: '53' },
  { label: '54 – Candidat au PQAF', value: '54' },
  { label: '55 – Professionnelle ou professionnel formé à l’étranger ayant reçu une prescription de l’OIIAQ et devant suivre une formation d’appoint', value: '55' },
  { label: '56 – Enfant à charge d’un boursier sélectionné par Éducation internationale', value: '56' },
  { label: '61 – Centre de détention', value: '61' },
  { label: '62 – Pouvoir d’exemption du ministre', value: '62' },
  { label: '63 – Pouvoir d’exemption du centre de services scolaire ou de la commission scolaire', value: '63' },
  { label: '70 – Citoyen canadien réside au Qc', value: '70' },
  { label: '71 – Résident permanent réside au Qc', value: '71' },
];
